import axios from 'axios';
import moment from 'moment';
// import store from '../store';

function errorHandler(error, reject) {
    // console.log(error);
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}

export default {
    get() {
    return new Promise(async (resolve, reject) => {
        try {
            const { data } = await axios.get(`koranperiode`);
            resolve(data);
        } catch (error) {
            errorHandler(error, reject);
        }
    });
    }, set(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.post("koranperiode/setcurrent", obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    }
};